import { createSlice } from "@reduxjs/toolkit";

type InitialState = {
    value: {
        selectedBlogPage: number;
        blogsLoading: boolean;
        allBlogs: any;
        selectedBlogId?: string;
        selectedBlogData?: any;
    }
};

const initialState = {
    value: {
        selectedBlogPage: 1,
        blogsLoading: true,
        allBlogs: null,
        selectedRecipeId: '',
        selectedRecipeData: null,
    }
} as InitialState;

export const blogSlice = createSlice({
    name: 'blogs',
    initialState,
    reducers: {
        setSelectedBlogPageRedux: (state, action) => {
            state.value.selectedBlogPage = action.payload;
        },
        setBlogsLoadingRedux: (state, action) => {
            state.value.blogsLoading = action.payload;
        },
        setAllBlogsRedux: (state, action) => {
            state.value.allBlogs = action.payload;
        },
        appendBlogsRedux: (state, action) => {
            const newBlogs = action.payload;
            if (state.value.allBlogs && Array.isArray(state.value.allBlogs)) {
                state.value.allBlogs = [...state.value.allBlogs, ...newBlogs];
            } else {
                state.value.allBlogs = newBlogs;
            }
        },
        setSelectedBlogId: (state, action) => {
            state.value.selectedBlogId = action.payload;
        },
        setSelectedBlogData: (state, action) => {
            state.value.selectedBlogData = action.payload;
        },
        updateSelectedBlogData: (state, action) => {
            const { key, value } = action.payload;
            if (state.value.selectedBlogData && key in state.value.selectedBlogData) {
                state.value.selectedBlogData[key] = value;
            } else {
                console.warn(`Key "${key}" is not found in selectedBlogData`);
            }
        },
    },
});

export const {
    setSelectedBlogPageRedux,
    setBlogsLoadingRedux,
    setAllBlogsRedux,
    appendBlogsRedux,
    setSelectedBlogId,
    setSelectedBlogData,
    updateSelectedBlogData,
} = blogSlice.actions;
export default blogSlice.reducer;